import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { Persona } from '../models/persona';
import { catchError} from 'rxjs/operators';
import swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Respuesta } from '../interfaces/respuesta.interface';


declare var $;
@Injectable({
  providedIn: 'root'
})
export class PersonaService {
  
  private respuesta: Response = new Response();

  //private baseEndPoint='http://cnsfdesmic3:9009/cnsf/agentesDescargaCedula'; //>>>>DESARROLLO
  //private baseEndPoint='https://cnsfdesmic3.cnsf.gob.mx/zuulO2/cnsf/agentesDescargaCedula'; //>>>>DESARROLLO_v2
   
  //private baseEndPoint='https://cnsfdesprorr.cnsf.gob.mx/zuulO2/cnsf/agentesDescargaCedula'
  private baseEndPoint='https://ceduladigital.cnsf.gob.mx/zuulO2/cnsf/agentesDescargaCedula'; //>>>>PRODUCCION
  //private baseEndPoint='https://ceduladigitaldrp.cnsf.gob.mx/zuulO2/cnsf/agentesDescargaCedula'; //>>>>DRP
  //private baseEndPoint='http://localhost:8900'; //>>>>LOCAL


  private httpHeaders = new HttpHeaders({'Content-Type': 'application/json'});
  httpHeadersToken = new HttpHeaders ({
    'Content-Type': 'application/x-www-form-urlencoded',
    'Authorization': 'Basic ' + btoa('cedulaDigitalUpload' + ':' + '242431134242') 
  });
 
  constructor(private http: HttpClient,
    private route:Router) {
           
     }
    
   
    obtenToken(user: string, passw: string): Observable<Respuesta>{
      
      let body= { usuario :user, pass :passw };

      return this.http.post<Respuesta>(this.baseEndPoint + '/token/ingreso',body,{headers: this.httpHeaders}).pipe(
        catchError(e => {
          this.route.navigate(['/cedulas']);
          swal.fire('Error', "Fallo al intentar ingresar al sistema, Verifique Usuario, Contraseña y vuelva a intentar.");
          return throwError(e);
        })
      );
    }
  
    logear(user: string, passw: string): Observable<Persona> {

      let body= { usuario :user, pass :passw };

      return this.http.post<Persona>(this.baseEndPoint + '/login',body,{headers: this.httpHeaders}).pipe(
        catchError(e => {
          this.route.navigate(['/cedulas']);
          /*swal.fire('Error', "Fallo al intentar ingresar al sistema, Verifique Usuario, Contraseña y vuelva a intentar. El server manda el siguiente error : " 
                    + e.error.mensaje , 'error');*/
          swal.fire('Error', "Error al ingresar usuario y/o contraseña <br><br> <b>Nota:</b> Verifique que el usuario y/o contraseña no contenga espacios en blanco al momento de copiar y pegar.", 'error');
                    
          return throwError(e);
      })
    );
  }
  
  getPersona(rfc: string):Observable<Persona>{
    return this.http.get<Persona>(`${this.baseEndPoint}/agente/${rfc}`).pipe(
      catchError(e => {
        console.error(e.error.mensaje)
        swal.fire('Error al editar', e.error.mensaje,'error');
        return throwError(e);
      })
    )

  }
  
  cambiaIngreso(persona: Persona): Observable<any>{
    return this.http.put<any>(`${this.baseEndPoint}/cambiaIngreso/${persona.rfc}`,  persona,{headers: this.httpHeaders}).pipe(
      catchError(e => {
        if(e.status == 400){
          swal.fire(e.error.mensaje, e.error.error,'error');
          return throwError(e);
        } else {
          swal.fire(e.error.mensaje, e.error.error,'error');
          return throwError(e);
        }
      })
    )
  }

  restablecer(user: string): Observable<any>{
    let body= { usuario :user};
    return this.http.post<Persona>(`${this.baseEndPoint}/restablecer`, body, {headers: this.httpHeaders});  
  }

  buscarUsuario(user: string): Observable<any>{
    let body= { usuario :user};
    return this.http.post<Persona>(`${this.baseEndPoint}/buscarUsuario`, body, {headers: this.httpHeaders});  
  }

}
